import type { ReactNode } from 'react';
import { Box, Typography } from '@mui/material';
import type { SvgIconComponent } from '@mui/icons-material';

/** État vide : icône + libellé court, action facultative. */
export default function EmptyState({ icon: Icon, label, action }: { icon: SvgIconComponent; label: string; action?: ReactNode }) {
  return (
    <Box sx={{ py: { xs: 5, sm: 7 }, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1.5 }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          bgcolor: 'action.hover',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Icon sx={{ color: 'text.disabled', fontSize: 28 }} />
      </Box>
      <Typography color="text.secondary">{label}</Typography>
      {action}
    </Box>
  );
}
